/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Price_Dgmm_SubInputs */

const es_landing_price_dgmm_sub = /** @type {(inputs: Landing_Price_Dgmm_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anotación en la Hoja de Asiento`)
};

const gl_landing_price_dgmm_sub = /** @type {(inputs: Landing_Price_Dgmm_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anotación na Folla de Asento`)
};

const en_landing_price_dgmm_sub = /** @type {(inputs: Landing_Price_Dgmm_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entry on the Registry Sheet`)
};

/**
* | output |
* | --- |
* | "Entry on the Registry Sheet" |
*
* @param {Landing_Price_Dgmm_SubInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_price_dgmm_sub = /** @type {((inputs?: Landing_Price_Dgmm_SubInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Price_Dgmm_SubInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_price_dgmm_sub(inputs)
	if (locale === "en") return en_landing_price_dgmm_sub(inputs)
	return es_landing_price_dgmm_sub(inputs)
});